import { render } from "./Styleguide-ComponentParams.vue?vue&type=template&id=08f7c155"
import script from "./Styleguide-ComponentParams.vue?vue&type=script&lang=js"
export * from "./Styleguide-ComponentParams.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__